import React, { useState } from "react";
import axios from "axios";
import { useToast } from "../Alerts/Toast";

const API = process.env.REACT_APP_API_BASE || "http://localhost:5000";

const ImageUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const toast = useToast();

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files?.[0] || null);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.info("Будь ласка, виберіть файл", 2600);
      return;
    }

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      setUploading(true);
      const response = await axios.post(`${API}/upload`, formData);

      const filename = response?.data?.filename;
      toast.success(filename ? `Завантажено: ${filename}` : "Завантажено", 2200);

      setSelectedFile(null);
    } catch (error) {
      console.error("❌ Помилка при завантаженні:", error);
      toast.error("Сталася помилка при завантаженні", 3200);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <h3>Завантажити зображення</h3>

      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={uploading}
      />

      <button onClick={handleUpload} disabled={uploading}>
        {uploading ? "Завантаження..." : "Завантажити"}
      </button>
    </div>
  );
};

export default ImageUpload;